import { ApplicationData } from "../../javascript/tlc/ls2pac/ApplicationData";

export const eResourceRedirect = ( itemId, service ) => {
    return "eResource/redirect?" + $.param( {
        "itemId":     itemId,
        "patronId":   ApplicationData.currentUser.patronId,
        "service":    service
    } );
}